import { InjectionToken } from '@angular/core';
import { IConfigGlobalePortaleSaaS } from '@ebw-monorepo/utils';

export const CONFIG_SERVICE_ADAPTER: InjectionToken<IConfigService> = new InjectionToken<IConfigService>(
  'CONFIG_SERVICE_TOKEN'
);

export interface IConfigService {
  getConfigGlobale(): IConfigGlobalePortaleSaaS;
}
